export const CC_TROOP_ICONS: Record<string, string> = {
  archer: "archer.webp",
  babydragon: "babydragon.webp",
  barbarian: "barbarian.webp",
  bowler: "bowler.webp",
  dragon: "dragon.webp",
  headhunter: "headhunter.webp",
  icegolem: "icegolem.webp",
  icehound: "icehound.webp",
  balloon: "loon.webp",
  furnace: "furnace.webp",
  rocketloon: "rocketloon.webp",
  superminion: "superminion.webp",
  etitan: "etitan.webp",
  valk: "valk.webp",
  witch: "witch.webp",
  electrodragon: "electrodragon.webp",
  lavahound: "lavahound.webp",
  goblin: "goblin.webp",
  infernodragon: "infernodragon.webp",
  wizard: "wizard.webp",
};

export function getTroopIcon(slug: string): string | null {
  const key = slug.toLowerCase().replace(/\s+/g, "");
  const file = CC_TROOP_ICONS[key];
  if (!file) return null;

  return `/images/cctroops/${file}`;
}